import React, { Component } from "react";
import "../../assets/bootstrap/css/bootstrap.min.css";
import "../../assets/fonts/font-awesome.min.css";
import "../../assets/css/styles.css";
import axios from "axios";
import $ from "jquery";

export class Gynecology2Sidebar extends Component {
  constructor(props) {
    super(props);

   

    // const url = 'hghobs.keshonect.co.ke'

    this.state = {
      module: "",
      profession: "",
      name: "",
      nationality: "",
      age: "",
    };

    // this.handleChange = this.handleChange.bind(this);
    // this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    console.log(localStorage.getItem("accessToken"));
    console.log(localStorage.getItem("currentVisitId"));
    console.log(localStorage.getItem("currentVisitName"));
    console.log(localStorage.getItem("currentVisitNationality"));
    console.log(localStorage.getItem("currentVisitProfession"));
    console.log(localStorage.getItem("currentVisitAge"));
    this.setState({
      age: localStorage.getItem("currentVisitAge"),
      name: localStorage.getItem("currentVisitName"),
      nationality: localStorage.getItem("currentVisitNationality"),
      profession: localStorage.getItem("currentVisitProfession"),
    });

    $(".Dashboard-class").click(function (e) {
      // e.PreventDefault()
      localStorage.removeItem("currentVisitId");
      localStorage.removeItem("currentVisitName");
      localStorage.removeItem("currentVisitNationality");
      localStorage.removeItem("currentVisitProfession");
      localStorage.removeItem("currentVisitAge");
      setTimeout(function () {
        window.location.href = "/triage/init/dashboard";
      }, 500);
    });

    if (localStorage.getItem("currentVisitName")) {
      $(".patientDetails").show();
    }
    $(".close").on("click", function () {
      $(".modal").hide();
    });
    if (localStorage.getItem("accessToken") == null) {
      $("#loginFirst").show();
      // window.location.href = '/'
    }
  }
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const { profession, name, nationality, age } = this.state;
    return (
      <div>
        <div className="sidebar-container">
          {/* <div className="sidebar-logo">
						Project Name
					</div> */}
          <ul className="sidebar-navigation">
            <li className="header patientDetails" style={displayHidden}>
              <h4>Patient Details</h4>
              <br />
              <b> Name: </b>
              {name}
              <br />
              <b>Nationality: </b>
              {nationality}
              <br />
              <b>Age: </b>
              {age}
              <br />
              <b>Profession: </b>
              {profession}
              <input type="hidden" value={name} className="patientName" />
            </li>

            <li>
              <a href="/general/observations">
                <i className="fa fa-plus-square" aria-hidden="true"></i>General
                Observations
              </a>
            </li>

            <li>
              <a href="/gynecology2/menstrual/history">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Menstrual History
              </a>
            </li>

            <li>
              <a href="/gynecology2/previous/obstetricsHistory">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Previous Obstetrics History
              </a>
            </li>
            <li>
              <a href="/gynecology2/antenatal/history">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Antenatal History
              </a>
            </li>
            <li>
              <a href="/gynecology2/ob/sound">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Obstetrics UltraSound
              </a>
            </li>

            <li>
              <a href="/gynecology2/preplan/analysis">
                <i className="fa fa-plus-square" aria-hidden="true"></i> Preplan
                Analysis Executed
              </a>
            </li>

            <li>
              <a href="/gynecology2/physical/examination">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Physical Examination
              </a>
            </li>

            <li>
              <a href="/gynecology2/previous/pregancy/complication">
                <i className="fa fa-plus-square" aria-hidden="true"></i>Previous
                Pregnancy Complication
              </a>
            </li>

            <li>
              <a href="/gynecology2/utilization/of/drugs">
                <i className="fa fa-plus-square" aria-hidden="true"></i>
                Utilization Of Drugs
              </a>
            </li>

            <li>
              <a href="/gynecology2/sexual/history">
                <i className="fa fa-plus-square" aria-hidden="true"></i>Sexual
                History
              </a>
            </li>

            <li>
              <a href="/gynecology2/prior/ob/or/gyn/infections">
                <i className="fa fa-plus-square" aria-hidden="true"></i>Prior Ob
                or Gyn Infections
              </a>
            </li>

            <li>
              <a href="/gynecology2/medical/disorders">
                <i className="fa fa-plus-square" aria-hidden="true"></i>Medical
                Disorders
              </a>
            </li>

            <li>
              <a href="/gynecology2/previous/abdominal">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Previous gynecological or abdominal surgery disorders
              </a>
            </li>

            <li>
              <a href="/gynecology2/physical/examination">
                <i className="fa fa-plus-square" aria-hidden="true"></i>Physical
                Examination General
              </a>
            </li>

            <li>
              <a href="/gynecology2/physical/examination/inspection">
                <i className="fa fa-plus-square" aria-hidden="true"></i>Physical
                Examination Inspection
              </a>
            </li>
            <li>
              <a href="/gynecology2/physical/examination/pelvic">
                <i className="fa fa-plus-square" aria-hidden="true"></i>Physical
                Examination Pelvic
              </a>
            </li>
            <li>
              <a href="/gynecology2/physical/examination/induction">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Physical Examination Induction
              </a>
            </li>
            <li>
              <a href="/tests/to/be/done">
                <i className="fa fa-plus-square" aria-hidden="true"></i> Tests
                To Be Done In the Lab
              </a>
            </li>
            <li>
              <a href="/post/natal/monitoring/form">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Monitoring Sheet
              </a>
            </li>

            <li>
              <a href="/post/natal/observation/management">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Observation and Management
              </a>
            </li>

            <li>
              <a href="/gynecology2/diagnosis/study">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Diagnosis and Plan
              </a>
            </li>
            <li>
              <a href="/send/to/module">
                <i className="fa fa-plus-square" aria-hidden="true"></i> Send To
                Module
              </a>
            </li>

            <li>
              <a href="/ward/round">
                <i className="fa fa-plus-square" aria-hidden="true"></i> Ward
                Round
              </a>
            </li>

            <li>
              <a href="/all/modules/data">
                <i className="fa fa-plus-square" aria-hidden="true"></i> All
                Module Data
              </a>
            </li>

            <li>
              <a href="/discharge/form">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Discharge Patient
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default Gynecology2Sidebar;
